import {Component, Optional, ViewChild} from '@angular/core';
import {CsvPropertiesConfirmResponse, CsvPropertiesMapRequest, FileUploadComponent} from '@cas-hub/acabim-common-client';
import {NGXLogger} from 'ngx-logger';
import {MessageService} from 'primeng/api';
import {ContactImportService} from '../../../_services/contact-import.service';

const enum CsvProcessingState {
    pending = 0, // Pending file upload
    waiting = 1, // Waiting for user to confirm
    processing = 2 // Processing the confirmation by the API
}

@Component({
    selector: 'acabim-admin-import-contacts',
    templateUrl: './import-contacts.component.html',
    styleUrls: ['./import-contacts.component.scss']
})
export class ImportContactsComponent {

    @ViewChild('csvUploader', {static: false}) public csvUploader?: FileUploadComponent;

    public csvProcessingState = CsvProcessingState.pending;

    public set csvMapRequest(req: CsvPropertiesMapRequest | undefined) {
        this._csvMapRequest = req;
        if (req) {
            this.csvProcessingState = CsvProcessingState.waiting;
        }
    }

    public get csvMapRequest(): CsvPropertiesMapRequest | undefined {
        return this._csvMapRequest;
    }

    private _csvMapRequest?: CsvPropertiesMapRequest;

    constructor(private readonly contactImportService: ContactImportService,
                public readonly messageService: MessageService,
                @Optional() private readonly logger?: NGXLogger) { }

    public startImportSession(): void {
        if (this.csvUploader && this.csvUploader.file) {
            this.csvUploader.startUpload(this.contactImportService.startSession(this.csvUploader.file, (result => {
                this.csvMapRequest = result;
            })));
        }
    }

    public confirmCsvMapRequest(result: CsvPropertiesConfirmResponse): void {
        this.csvProcessingState = CsvProcessingState.pending;
        this.contactImportService.confirmImport(result).subscribe(_ => {
            this.messageService.add({severity: 'success', summary: 'Contacts import request submitted successfully'});
            this.csvMapRequest = undefined;
            this.csvProcessingState = CsvProcessingState.pending;
        }, error => {
            this.logger?.error('[ImportUsersComponent] Import Failed', error);
            this.messageService.add({severity: 'error', summary: 'Unable to import your contact list'});
            this.csvProcessingState = CsvProcessingState.waiting;
        });
    }
}
